import * as Actions from './constants';

export const resetInsurer = () => {
  return { type: Actions.INSURANCE_ANKETA_RESET_INSURER };
};

export const setBatchState = (state) => {
  return { payload: state, type: Actions.INSURANCE_ANKETA_BATCH_STATE };
};

export const setDriverBatchState = ({ id, values }) => {
  return { payload: { id, values }, type: Actions.INSURANCE_ANKETA_DRIVER_BATCH_STATE };
};
